import { parseIframeComponentCore } from './component.iframe.core.js';

const parseIframeComponentFramework = (node) => {
  const referenceId = node.getAttribute("componentId");
  const coreConfig = parseIframeComponentCore(node);
  if (!referenceId || !coreConfig) {
    return null;
  }
  return {
    ...coreConfig,
    nodeType: "iframe-component.component-framework",
    referenceId
  };
};

export { parseIframeComponentFramework };
//# sourceMappingURL=component.iframe.component-framework.js.map
